import { App } from 'antd';

/**
 * Hook to access Ant Design's message API.
 * This replaces the static `message` import from 'antd'.
 *
 * Usage:
 * ```tsx
 * import useMessage from '@/hooks/useMessage';
 *
 * function MyComponent() {
 *   const message = useMessage();
 *
 *   const handleClick = () => {
 *     message.success('Success!');
 *   };
 * }
 * ```
 */
export default function useMessage() {
  const { message } = App.useApp();
  return message;
}
